import { render, staticRenderFns } from "./indexHeader.vue?vue&type=template&id=108680e0&scoped=true&"
import script from "./indexHeader.vue?vue&type=script&lang=js&"
export * from "./indexHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108680e0",
  null
  
)

export default component.exports